import moment from 'moment';
import { Button } from 'primereact/button';
import Tag from '../../../../components/Display/Tag';
import styles from "../../cards.module.scss"

function NewsItem({ news, handleClickNews, handleDuplicateNews, layout }) {
  return (
    <div
      className={`${styles.projectCard} ${layout === "grid" ? styles.projectCardGrid : ''}`}
      onClick={handleClickNews}>
      <div className={styles.contentContainer}>
        <div className={styles.topInfo}>
          <p className={styles.title}>{news.title}</p>
          <span className={styles.subtitle}>
            {moment(news.publication_date).format('ll')}
          </span>
        </div>
        <div className={styles.tagList}>
          {news.tags?.map((t, index) => (
            <Tag
              key={index}
              tag={{
                label: t.label,
                bgColor: 'bg-orange-700'
              }}
            />
          ))}
        </div>
      </div>
      <Button
        rounded
        icon="pi pi-clone"
        className={styles.button}
        tooltip="Dupliquer l'article"
        tooltipOptions={{ position: 'left' }}
        onClick={handleDuplicateNews}
        severity="secondary"
        outlined
      />
    </div>
  );
}

export default NewsItem;
